"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _eligibleRace = _interopRequireDefault(require("./eligible-race"));
var _bibDetails = _interopRequireDefault(require("../../../core/bib-details"));
var _table = _interopRequireDefault(require("../../../core/table"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "There are currently no events that you are eligible to enter. Please try later");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Select the race you want to enter. If you want to enter a double race, select both days.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Please note that if you enter a judges race and a ranking race on the same day without prior agreement, the organiser may cancel your judges entry without notice.");
var _ref4 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Competition"), /*#__PURE__*/_react.default.createElement("th", null, "Division/Event"), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null)));
class Races extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_canEnterCompetition", entryTypes => {
      return entryTypes.some(entryType => entryType.raceEligibilities.length > 0);
    });
    // Groups the eligibilities by competition + raceName
    _defineProperty(this, "_getGroupedEligibilities", entryTypeEligibilities => {
      // Get the races grouped by CompRaceName
      if (!entryTypeEligibilities.length) return [];
      const groupedEligibilities = entryTypeEligibilities.reduce((races, eligibility) => {
        const key = eligibility.race.competitionID + '*' + eligibility.race.raceName;
        if (!races[key]) races[key] = [];
        races[key].push(eligibility);
        return races;
      }, {});
      // The above returns an object keyed on competitionID + raceName
      // We can't .map an object so and now we've got the grouping we are not bothered
      // about the actual keys, so convert to an array
      return Object.keys(groupedEligibilities).map(key => groupedEligibilities[key]);
    });
  }
  render() {
    const classDivision = this.props.classDivision;
    const cseBibID = this.props.cseBibID;
    const entryTypes = this.props.isMultiCompetitionEntry ? this.props.entryTypes : this.props.competition.entryTypeOverrides;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.checkoutButton, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_bibDetails.default, {
      cseBibID: cseBibID
    }), !this._canEnterCompetition(entryTypes) ? _ref : /*#__PURE__*/_react.default.createElement("div", null, _ref2, _ref3, entryTypes.map(entryType => /*#__PURE__*/_react.default.createElement("div", {
      key: entryType.id
    }, !entryType.raceEligibilities.length ? null : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", null, entryType.description), /*#__PURE__*/_react.default.createElement(_table.default, null, _ref4, /*#__PURE__*/_react.default.createElement("tbody", null, this._getGroupedEligibilities(entryType.raceEligibilities).map(eligibilityGroup => eligibilityGroup.map((eligibility, i) => /*#__PURE__*/_react.default.createElement(_eligibleRace.default, {
      key: i,
      firstRace: i === 0 || eligibility.competition //in group
      ,
      eligibility: eligibility,
      classDivisionID: classDivision.id,
      cseBibID: cseBibID,
      cseBib: this.props.cseBib,
      setEntryError: this.props.setEntryError
    }))))))))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = {
  id: true
};
var _ref6 = _mergeBqlQueries({}, _eligibleRace.default.partialQueries.EligibilityStatus);
var _ref7 = _mergeBqlQueries({
  competitionID: true,
  raceName: true
}, _eligibleRace.default.partialQueries.Race);
var _ref8 = {
  id: true
};
var _ref9 = _mergeBqlQueries({}, _eligibleRace.default.partialQueries.EligibilityStatus);
var _ref10 = _mergeBqlQueries({
  competitionID: true,
  raceName: true
}, _eligibleRace.default.partialQueries.Race);
var _default = exports.default = (0, _reactBicycle.connect)(Races, props => {
  if (props.isMultiCompetitionEntry) {
    return {
      ["cseBib(cseBibID:" + JSON.stringify(+props.cseBibID) + ")"]: _ref5,
      entryTypes: {
        id: true,
        description: true,
        ["raceEligibilities(classDivisionID:" + JSON.stringify(+props.classDivisionID) + ",yearID:" + JSON.stringify(+props.yearID) + ")"]: {
          ["eligibilityStatus(cseBibID:" + JSON.stringify(+props.cseBibID) + ")"]: _ref6,
          race: _ref7
        }
      }
    };
  } else {
    return {
      ["cseBib(cseBibID:" + JSON.stringify(+props.cseBibID) + ")"]: _ref8,
      ["competition(competitionSlug:" + JSON.stringify(props.competitionSlug) + ",yearID:" + JSON.stringify(+props.yearID) + ")"]: {
        entryTypeOverrides: {
          id: true,
          "entryTypeDescription as description": true,
          ["raceEligibilities(classDivisionID:" + JSON.stringify(+props.classDivisionID) + ")"]: {
            ["eligibilityStatus(cseBibID:" + JSON.stringify(+props.cseBibID) + ")"]: _ref9,
            race: _ref10
          }
        }
      }
    };
  }
});